import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../../types";
import { FormSendDM } from "./FormSendDM";
import type { HistoryDetailViewDMProps } from "./HistoryDetailViewDM";
import { HistoryDetailViewDM } from "./HistoryDetailViewDM";
import { ViewDM } from "./ViewDM";

export const sendDM: Readonly<ActionOption<HistoryDetailViewDMProps>> = {
  label: t("settings.workflows.form.actions.send_dm"),
  textLabel: t("settings.workflows.form.actions.send_dm"),
  value: "send_dm",
  group: t("settings.workflows.form.action_groups.communication"),
  leftAddon: <Icon type="16-messages" size={16} className="!h-4 !w-4" />,
  formComponent: FormSendDM,
  viewComponent: ViewDM,
  historyDetailViewComponent: HistoryDetailViewDM,
  icon: "chat",
  isApplicableToMembersOnly: true,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
  disablable: true,
  disableToolTipText: t(
    "workflows_v2.action_selector.enable_dm_for_action_tooltip",
  ),
} as const;
